import { Box, Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import { isDifc, isTiac } from "Routes/Routes";
import Tabs from "features/Tabs/Tabs";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteDispute } from "slices/disputeSlice";

const useStyles = makeStyles((theme) => ({
  caseName: {
    fontSize: "1.15rem",
  },
  blue: {
    fontFamily: `Satoshi-Bold`,
    color: `${theme.palette.primary.main}`,
    textAlign: "right",
    cursor: "pointer",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.border}`,
    flexWrap: "wrap",
    gap: "8px"
  },
  tabContainer: {
    gap:'1.2rem',
    width:'auto',
    flexWrap: "nowrap",
    marginLeft: "auto",
  },
}));

export default function SidebarDisputes({
  profile,
  disputesActiveClaimant,
  disputesResolvedClaimant,
  disputesActiveRespondent,
  disputesResolvedRespondent,
  disputesActiveArbitrator,
  disputesResolvedArbitrator,
  history,
  removeDisputeFromList,
  showDirectDisputeName = false,
  // Label for the closed-cases tab; BAC (ACCB) shows "Disposal".
  closedTabLabel = "Closed",
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  // const [role, setRole] = useState('claimant');
  const [disputeType, setDisputeType] = useState("active");
  const [disputes, setDiputes] = useState([]);

  // const roleTabs = [
  // 	{
  // 		id: 'claimant',
  // 		label: 'As Claimant',
  // 	},
  // 	{
  // 		id: 'respondent',
  // 		label: 'As Respondent',
  // 	}
  // ]

  const disputeTypeTabs = [
    {
      id: "active",
      label: "Open",
    },
    {
      id: "resolved",
      label: closedTabLabel,
    },
  ];

  useEffect(() => {
    // if(role === 'claimant'){
    // 	if(disputeType === 'active'){
    // 		setDiputes(disputesActiveClaimant);
    // 	}
    // 	else{
    // 		setDiputes(disputesResolvedClaimant);
    // 	}
    // }
    // else{
    // 	if(disputeType === 'active'){
    // 		setDiputes(disputesActiveRespondent);
    // 	}
    // 	else{
    // 		setDiputes(disputesResolvedRespondent);
    // 	}
    // }
    if (
      [
        "arbitrator_rv",
        "mediator",
        "witness",
        "witness_rv",
        "expert_rv",
      ].includes(profile.profile_type)
    ) {
      if (disputeType === "active") {
        setDiputes(disputesActiveArbitrator);
      } else {
        setDiputes(disputesResolvedArbitrator);
      }
    } else {
      if (disputeType === "active") {
        setDiputes([...disputesActiveClaimant, ...disputesActiveRespondent]);
      } else {
        setDiputes([
          ...disputesResolvedClaimant,
          ...disputesResolvedRespondent,
        ]);
      }
    }
  }, [
    disputeType,
    disputesActiveClaimant,
    disputesResolvedClaimant,
    disputesActiveRespondent,
    disputesResolvedRespondent,
    disputesActiveArbitrator,
    disputesResolvedArbitrator,
    profile.profile_type,
  ]);

  // const handleClickOnRoleTab = (tab) => {
  // 	setRole(tab);
  // }

  const handleClickOnDisputeTypeTab = (tab) => {
    setDisputeType(tab);
  };

  const getSubtitleText = (dispute, isDraftDispute) => {
    if(isDifc){
      return dispute?.id;
    } else if(dispute?.tiac_custom_dispute_id){
      return dispute?.tiac_custom_dispute_id;
    } else if(isDraftDispute){
      return '[DRAFT]'
    } else {
      return '';
    }
  }

  const handleDeleteDraftDispute = async (id) => {
    const res = await dispatch(deleteDispute(id));
    if(res?.status === 200){
      removeDisputeFromList(id, disputeType, profile.profile_type, 'claimant');
    }
  }

  return (
    <>
      <Box>
        <Box height="2.5rem" />
        <div
          className={classes.header}
          style={isTiac ? { justifyContent: "flex-end" } : null}
        >
          {!isTiac && (
            <Typography variant="h1" style={{ fontWeight: 600, fontSize: '1.3rem' }}>
              {`Hi, ${profile.user.first_name}`}
            </Typography>
          )}
          {/* <Tabs
						tabs={roleTabs}
						handleClickTab={handleClickOnRoleTab}
						choice={role}
					/> */}
          <Tabs
            tabs={disputeTypeTabs}
            handleClickTab={handleClickOnDisputeTypeTab}
            choice={disputeType}
            tabsContainerClass={classes.tabContainer}
          />
        </div>
        <Box height="1.5rem" />
        {disputes?.map((dispute, index) => {
          let disputeName = dispute?.name.split("v.");
          const isDraftDispute = dispute?.tiac_dispute_step !== 'form_complete' && dispute?.tiac_dispute_step !== "additional_info_complete";
          if (disputeName.length === 1) {
            disputeName = dispute?.name.split("vs");
          }
          return (
            <React.Fragment key={dispute.id + disputes.length - index}>
              <Grid container justify="space-between">
                <Grid item xs={9}>
                  {showDirectDisputeName ? (
                    <Typography className={classes.caseName}>
                      {dispute?.name}
                    </Typography>
                  ) : (
                    <Typography className={classes.caseName}>
                      {disputeName[0]}
                      <span
                        style={{
                          color: "#898989",
                          fontFamily: "Satoshi-Regular",
                        }}
                      >
                        vs
                      </span>
                      {disputeName[1]}
                    </Typography>
                  )}
                  <Typography
                    style={{
                      color: "#898989",
                      fontFamily: "Satoshi-Regular",
                      fontSize: "1rem",
                    }}
                  >
                    {getSubtitleText(dispute, isDraftDispute)}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <div style={{display:'flex',gap:'8px', justifyContent:'flex-end', alignItems:'center'}}>
                    {isDraftDispute && (
                      <IconButton
                      style={{padding:0}}
                      onClick={() => handleDeleteDraftDispute(dispute.id)}
                      >
                        <DeleteOutline color="primary"/>
                      </IconButton>
                    )}
                    <Typography
                      className={classes.blue}
                      onClick={() => {
                        history.push(`disputes/${dispute.id}`);
                      }}
                    >
                      VIEW
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Box height="1rem" />
            </React.Fragment>
          );
        })}
      </Box>
    </>
  );
}
